import {redirect} from 'react-router';
import {apiClient} from '@common/http/query-client';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import {resolveDefaultFreeClassicsDecade} from '@app/free-classics/resolve-default-free-classics-decade';
import {FreeClassicsMetadataResponse} from '@app/free-classics/free-classics-types';

export async function freeClassicsIndexLoader() {
  const bootstrap = getBootstrapData().loaders?.freeClassicsPage;

  if (bootstrap?.metadata) {
    return redirect(
      `/free-classics/${resolveDefaultFreeClassicsDecade(bootstrap.metadata)}`,
    );
  }

  const metadata = await apiClient
    .get<FreeClassicsMetadataResponse>('free-classics')
    .then(response => response.data);

  return redirect(
    `/free-classics/${resolveDefaultFreeClassicsDecade(metadata)}`,
  );
}
